import script from "./FormSelectField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormSelectField.vue?vue&type=script&lang=ts&setup=true"

import "./FormSelectField.vue?vue&type=style&index=0&id=5531befc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5531befc"]])

export default __exports__